var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"iframeDom",attrs:{"srcdoc":_vm.html,"frameborder":"0"},on:{"load":_vm.onIframeLoad}})
}
var staticRenderFns = []

export { render, staticRenderFns }